import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BankStatementRuleConditionTypeEnum } from '@zaoblako/shared/modules/document/enums/bank.statement.rule.condition.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { BankStatementRuleConditionTypeNamePipe } from '@zaoblako/web/shared/pipes/bank-statement-rule-condition-type-name.pipe';

@Component({
  selector: 'crm-bank-statement-rule-condition-type-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, BankStatementRuleConditionTypeNamePipe],
  templateUrl: './bank-statement-rule-condition-type-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BankStatementRuleConditionTypeSingleSelectComponent {
  @Input() public type: BankStatementRuleConditionTypeEnum;
  @Output() public typeChange = new EventEmitter<BankStatementRuleConditionTypeEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: any;

  public options = Object.values(BankStatementRuleConditionTypeEnum);
}
